import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { uploadInjectionKey as x } from "./interface.js";
import E from "./UploadDragger.js";
import { getFilesFromEntries as O } from "./utils.js";
import { throwError as k } from "../../_utils/naive/warn.js";
import { resolveSlot as A } from "../../_utils/vue/resolve-slot.js";
import F from "../../_internal/icon/src/Icon.js";
import N from "../../_internal/icons/Add.js";
import { defineComponent as U, inject as j, computed as P, h as n } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
const z = U({
  name: "UploadTrigger",
  props: {
    abstract: Boolean
  },
  slots: Object,
  setup(c, {
    slots: l
  }) {
    const u = j(x, null);
    u || k("upload-trigger", "`n-upload-trigger` must be placed inside `n-upload`.");
    const {
      mergedClsPrefixRef: D,
      mergedDisabledRef: o,
      maxReachedRef: i,
      listTypeRef: h,
      dragOverRef: a,
      openOpenFileDialog: R,
      draggerInsideRef: T,
      handleFileAddition: y,
      mergedDirectoryDndRef: C,
      triggerClassRef: b,
      triggerStyleRef: I
    } = u, g = P(() => h.value === "image-card");
    function f() {
      o.value || i.value || R();
    }
    function v(e) {
      e.preventDefault(), a.value = !0;
    }
    function p(e) {
      e.preventDefault(), a.value = !0;
    }
    function s(e) {
      e.preventDefault(), a.value = !1;
    }
    function m(e) {
      var r;
      if (e.preventDefault(), !T.value || o.value || i.value) {
        a.value = !1;
        return;
      }
      const t = (r = e.dataTransfer) === null || r === void 0 ? void 0 : r.items;
      t != null && t.length ? O(Array.from(t).map((d) => d.webkitGetAsEntry()), C.value).then((d) => {
        y(d);
      }).finally(() => {
        a.value = !1;
      }) : a.value = !1;
    }
    return () => {
      var e;
      const {
        value: r
      } = D;
      return c.abstract ? (e = l.default) === null || e === void 0 ? void 0 : e.call(l, {
        handleClick: f,
        handleDrop: m,
        handleDragOver: v,
        handleDragEnter: p,
        handleDragLeave: s
      }) : n("div", {
        class: [`${r}-upload-trigger`, (o.value || i.value) && `${r}-upload-trigger--disabled`, g.value && `${r}-upload-trigger--image-card`, b.value],
        style: I.value,
        onClick: f,
        onDrop: m,
        onDragover: v,
        onDragenter: p,
        onDragleave: s
      }, g.value ? n(E, null, {
        default: () => A(l.default, () => [n(F, {
          clsPrefix: r
        }, {
          default: () => n(N, null)
        })])
      }) : l);
    };
  }
});
export {
  z as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/upload/src/UploadTrigger.js
// module id = 983
// module chunks = 67